import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'
import ZoomingAnimation from './partials/ZoomingAnimation'
import { tsToDate } from './utils/tsToDate'
import firebase from 'firebase'

function Timetable() {
    const { userDetails } = useAuthContext()

    const [timetable, setTimetable] = useState([])
    const [loading, setLoading] = useState(false)

    const backgrounds = [
        'linear-gradient(180deg, #079CFF 0%, #3366FF 100%)',
        'linear-gradient(167.6deg, #FF5A8E -9.78%, #FC7563 107.04%)',
        'linear-gradient(178.76deg, #36C687 1%, #039C59 97.45%)'
    ]

    useEffect(() => {
        const today = new Date()
        const todayAt00 = new Date(
            `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`
        )

        const timetableListner = DB.collection('timetable')
            .where(
                'time',
                '>=',
                firebase.firestore.Timestamp.fromDate(todayAt00)
            )
            .where('batch', '==', userDetails?.batch?.batchName)
            .orderBy('time', 'asc')
            .onSnapshot((querySnapshot) => {
                var arr = []
                querySnapshot.forEach((doc) => {
                    arr.push({
                        id: doc.id,
                        ...doc.data()
                    })
                })
                setTimetable(arr)
                setLoading(false)
            })

        setLoading(true)
        return () => timetableListner
    }, [])

    return (
        <TimetableContainer>
            <Heading>Timetable</Heading>

            {!!!timetable.length && loading && <ZoomingAnimation />}

            {!!timetable.length &&
                timetable.map((item, key) => (
                    <TimetableCard key={key}>
                        <DateInCard backgrounds={backgrounds[key]}>
                            {tsToDate(item?.time)[1]}
                        </DateInCard>
                        <SubjectFaculty>{item?.subjectFaculty}</SubjectFaculty>
                        <Time>{tsToDate(item?.time)[2]}</Time>
                    </TimetableCard>
                ))}

            {!!!timetable.length && !loading && (
                <NotAvailable>No Timetable Available</NotAvailable>
            )}
        </TimetableContainer>
    )
}

const TimetableContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const TimetableCard = styled.div`
    margin: 30px auto;
    width: 100%;
    max-width: 400px;
    background: linear-gradient(
            112.42deg,
            #2e2e53 8.39%,
            #2e2e53 55.23%,
            #2e2e53 85.97%
        ),
        #292948;
    border: 2px solid #363862;
    box-sizing: border-box;
    box-shadow: 9px 9px 16px rgba(30, 34, 50, 0.6);
    border-radius: 5px 5px 30px 30px;
    padding: 20px;
    padding-top: 50px;
    position: relative;
`

const DateInCard = styled.p`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 12px 30px;
    background: ${({ backgrounds }) => backgrounds};
    border-radius: 5px 5px 20px 20px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    width: 100%;
    max-width: 220px;
`
const SubjectFaculty = styled.p`
    color: #dee3ff;
    text-align: center;
    font-weight: 500;
    font-size: 15px;
`
const Time = styled.p`
    color: #b0e7ff;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    padding-top: 20px;
`

const NotAvailable = styled.p`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`

export default Timetable
